import React, { useEffect } from "react";
import Footer from "../common/footer";
import Menubar from "../common/Menubar";
import Topnav from "../common/Topnav";
import { Link } from "react-router-dom";
import imgLMS from "../../Images/commonimg/messagesticker.webp";
import lmslaptop from "../../Images/commonimg/lms-laptop.webp";
import acadShape1 from "../../Images/commonimg/acadenic-shape-1.webp";
import acadShape2 from "../../Images/commonimg/acadenic-shape-2.webp";
import Questionmark from "../../Images/commonimg/Questionmark.webp";
import shapelight from "../../Images/commonimg/shape-light.webp";
import campusshape2 from "../../Images/commonimg/campus-shape-2.webp";
import studentshape05 from "../../Images/commonimg/student-shape-05.webp";
import campusimg1 from "../../Images/commonimg/campus-img-1.webp";
import campusimg2 from "../../Images/commonimg/campus-img-2.webp";
import campusimg3 from "../../Images/commonimg/campus-img-3.webp";
import campusimg4 from "../../Images/commonimg/campus-img-4.webp";
import campusimg5 from "../../Images/commonimg/campus-img-5.webp";
import campusshape1 from "../../Images/commonimg/campus-shape-1.webp";
import infographics25 from "../../Images/commonimg/info-graphics-25.webp";
import { BsDownload } from "react-icons/bs";

import { MetaTags } from "react-meta-tags";

const Isbm_pro = () => {
  return (
    <div>
      <MetaTags>
        <title>
          ISBM PRO | Video Lectures | Enrich Your Knowledge | Skill Development
        </title>
        <meta
          name="description"
          content="ISBM PRO Helps You To Enrich Your Knowledge & Accomplish The Goal. Video Lecture Which Are Easy To Excess. eBooks For All Categories & Many More"
        />
        <link rel="canonical" href="https://isbmuniversity.edu.in/Isbm-pro" />
        <meta
          name="SearchEngines"
          content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET, DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
        />
        <meta name="Robots" content="INDEX, FOLLOW" />
        <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
        <meta name="Robots" content="INDEX,ALL" />
        <meta name="YahooSeeker" content="INDEX, FOLLOW" />
        <meta name="msnbot" content="INDEX, FOLLOW" />
        <meta name="googlebot" content="Default, follow" />
        <meta name="owner" content="isbmuniversity.edu.in/" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="2 days" />
        <meta
          property="og:title"
          content="ISBM PRO | Video Lectures | Enrich Your Knowledge | Skill Development"
        />
        <meta
          property="og:description"
          content="ISBM PRO Helps You To Enrich Your Knowledge & Accomplish The Goal. Video Lecture Which Are Easy To Excess. eBooks For All Categories & Many More"
        />
        <meta
          property="og:url"
          content="https://isbmuniversity.edu.in/Isbm-pro/"
        />
        <meta
          property="og:image"
          content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
        />
        <meta property="og:image:alt" content="ISBM University" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="ISBM University" />
        <meta
          name="twitter:title"
          content="ISBM PRO | Video Lectures | Enrich Your Knowledge | Skill Development"
        />
        <meta
          name="twitter:description"
          content="ISBM PRO Helps You To Enrich Your Knowledge & Accomplish The Goal. Video Lecture Which Are Easy To Excess. eBooks For All Categories & Many More"
        />
        <meta
          name="twitter:image:src"
          content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@ISBMUniversity" />
        <meta name="twitter:creator" content="@ISBMUniversity" />
        <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
        <meta property="twitter:account_id" content="758619542734053376" />
      </MetaTags>
      <Topnav />
      <Menubar />
      <div className="isbm_pro">
        <div>
          <main>
            <div className="isbmuproimg hero-height-3">
              <div className="hero-university-text">
                <h2>Build Your Dream with ISBM UNIVERSITY</h2>
              </div>
            </div>

            <div className="university-card">
              <div className="container">
                <div className="row ">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="university-main-wraper row align-items-center">
                      <div className="university-course-box col-lg-3 col-sm-12">
                        <div className="text-white mt-4 p-4">
                          <p className="fw-bolder">All in One</p>
                          <h3>
                            Earn Your Degree in your <span>community</span>
                          </h3>
                          {/* <button className="px-3 py-2 edu-six-btn ">
                            <Link to="/school-of-commerce" className=" text-dark fw-bolder">View courses</Link>
                          </button> */}
                        </div>
                      </div>
                      <div className="university-card-wrapper col-lg-3 col-sm-12 col-md-12">
                        <div className="university-card-icon">
                          <svg
                            id="Page-1"
                            xmlns="http://www.w3.org/2000/svg"
                            width="31.154"
                            height="31.157"
                            viewBox="0 0 31.154 31.157"
                          >
                            <g
                              id="_001---Degree"
                              data-name="001---Degree"
                              transform="translate(0 0)"
                            >
                              <path
                                id="Shape"
                                d="M45.965,36.371c0,2.965-.483,5.371-1.074,5.371A82.894,82.894,0,0,0,34,40.733L32.666,40.1A3.214,3.214,0,0,0,32,36.119c-.016-1.783.816-3.309.478-4.066A86.359,86.359,0,0,0,44.891,31C45.482,31,45.965,33.406,45.965,36.371Z"
                                transform="translate(-14.811 -14.349)"
                                fill="#f8e8ab"
                              ></path>
                              <path
                                id="Shape-2"
                                data-name="Shape"
                                d="M8.062,9.164l-7.7-2.75a.537.537,0,0,1,0-1.01L15.394.032a.565.565,0,0,1,.376,0L30.8,5.4a.537.537,0,0,1,0,1.01l-3.438,1.23-1.488.532L23.1,9.164Z"
                                transform="translate(-0.005 0)"
                                fill="#393f4b"
                              ></path>
                              <g
                                id="Group_2930"
                                data-name="Group 2930"
                                transform="translate(1.074 16.651)"
                              >
                                <path
                                  id="Shape-3"
                                  data-name="Shape"
                                  d="M2.075,50.97,2,50.986A.171.171,0,0,0,2.075,50.97Z"
                                  transform="translate(-2 -40.243)"
                                  fill="#f8e8ab"
                                ></path>
                                <path
                                  id="Shape-4"
                                  data-name="Shape"
                                  d="M2.064,31.011A.608.608,0,0,1,2,31,.268.268,0,0,1,2.064,31.011Z"
                                  transform="translate(-2 -31)"
                                  fill="#f8e8ab"
                                ></path>
                                <path
                                  id="Shape -5"
                                  data-name="Shape"
                                  d="M2.13,31.02a85.412,85.412,0,0,0,11.683,1.026c.355.784,1.676,2.433,1.676,4.335,0,.129,0,.252-.005.376a3.223,3.223,0,0,0-.118,3.352l-1.327.6a87.272,87.272,0,0,0-11.9,1.026Z"
                                  transform="translate(-2.06 -31.009)"
                                  fill="#f8e8ab"
                                ></path>
                              </g>
                              <path
                                id="Shape-6"
                                data-name="Shape"
                                d="M24.476,37.641c.005-.124.005-.247.005-.376a12.333,12.333,0,0,0-.6-4.335c.881.027,1.8.038,2.75.038.714,0,1.413-.005,2.089-.021a11.78,11.78,0,0,1,.591,4.066Z"
                                transform="translate(-11.053 -15.242)"
                                fill="#ba3a23"
                              ></path>
                              <path
                                id="Shape-7"
                                data-name="Shape"
                                d="M26.153,49.584l-1.429,3.422a.537.537,0,0,1-.994.016l-.392-.9-.9.387a.533.533,0,0,1-.709-.688l1.364-3.277.252-.6Z"
                                transform="translate(-10.039 -22.19)"
                                fill="#ba3a23"
                              ></path>
                              <path
                                id="Shape-8"
                                data-name="Shape"
                                d="M32.809,47.94l.263.634,1.354,3.244a.533.533,0,0,1-.709.688l-.9-.387-.392.9a.537.537,0,0,1-.994-.016L30,49.584Z"
                                transform="translate(-13.886 -22.19)"
                                fill="#ba3a23"
                              ></path>
                              <path
                                id="Shape-9"
                                data-name="Shape"
                                d="M15,17.52V11.611C15,10.72,18.368,10,22.52,10s7.52.72,7.52,1.611V17.52Z"
                                transform="translate(-6.943 -4.629)"
                                fill="#464f5e"
                              ></path>
                              <path
                                id="Shape-10"
                                data-name="Shape"
                                d="M49.537,11.038A.537.537,0,0,1,49,10.5V6.977a.537.537,0,1,1,1.074,0V10.5A.537.537,0,0,1,49.537,11.038Z"
                                transform="translate(-22.68 -2.981)"
                                fill="#edc100"
                              ></path>
                              <path
                                id="Shape-11"
                                data-name="Shape"
                                d="M48,15.074v1.611a.537.537,0,0,0,.537.537h1.074a.537.537,0,0,0,.537-.537V15.074a1.074,1.074,0,0,0-2.149,0Z"
                                transform="translate(-22.217 -6.48)"
                                fill="#f1d24b"
                              ></path>
                              <ellipse
                                id="Oval"
                                cx="7.52"
                                cy="1.611"
                                rx="7.52"
                                ry="1.611"
                                transform="translate(8.057 11.28)"
                                fill="#393f4b"
                              ></ellipse>
                              <path
                                id="Shape-12"
                                data-name="Shape"
                                d="M2.149,36.371c0,2.836-.44,5.162-1,5.355a.171.171,0,0,1-.075.016C.483,41.743,0,39.336,0,36.371S.483,31,1.074,31a.02.02,0,0,1,.016.005c.011,0,.027.005.048.005h.005C1.7,31.2,2.149,33.524,2.149,36.371Z"
                                transform="translate(0 -14.349)"
                                fill="#e2be50"
                              ></path>
                              <path
                                id="Shape-13"
                                data-name="Shape"
                                d="M30.446,42.223A3.223,3.223,0,1,1,27.223,39a3.157,3.157,0,0,1,2.143.822A3.2,3.2,0,0,1,30.446,42.223Z"
                                transform="translate(-11.109 -18.052)"
                                fill="#e04c34"
                              ></path>
                            </g>
                          </svg>
                        </div>
                        <div className="university-card-content">
                          <h3>Wider Range of Courses and Programmes</h3>
                          <p>
                            For students, the long-term goal is obviously to
                            offer a wide variety of courses and learning
                            experiences.
                          </p>
                        </div>
                      </div>
                      <div className="university-card-wrapper col-lg-3 col-sm-12">
                        <div className="university-card-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="27.226"
                            height="31.157"
                            viewBox="0 0 27.226 31.157"
                          >
                            <g
                              id="graduation"
                              transform="translate(-14.464 -7.667)"
                            >
                              <path
                                id="Path_7625"
                                data-name="Path 7625"
                                d="M56.083,71.641s0,0,0-.007a10.235,10.235,0,0,1-1.452,1.333,4.43,4.43,0,0,1-2.642,1.053h-.174a4.418,4.418,0,0,1-2.63-1.053,10.222,10.222,0,0,1-1.444-1.323s0,0,0,.007l-.4,2.3a.23.23,0,0,0,.1.235l3.029,2.072a.318.318,0,0,0,.18.055h2.547a.32.32,0,0,0,.181-.055l3.029-2.071a.23.23,0,0,0,.1-.235Z"
                                transform="translate(-23.827 -46.381)"
                                fill="#ffd0ca"
                              ></path>
                              <path
                                id="Path_7626"
                                data-name="Path 7626"
                                d="M15.775,89.338a.279.279,0,0,1-.275-.286l.192-4.772c.073-1.8,1.588-2.74,2.722-3.294.429-.209.867-.4,1.29-.59a9.986,9.986,0,0,0,4-2.584.28.28,0,0,1,.366-.055l3.788,2.508h1.943l3.809-2.486a.278.278,0,0,1,.362.055A10.307,10.307,0,0,0,37.984,80.4c.422.188.852.38,1.269.583,1.134.554,2.65,1.5,2.722,3.294l.192,4.772a.278.278,0,0,1-.275.286Z"
                                transform="translate(-0.751 -50.789)"
                                fill="#cdcdcf"
                              ></path>
                              <path
                                id="Path_7627"
                                data-name="Path 7627"
                                d="M52.862,105.74l1.454-5.407h3.217l1.453,5.407Z"
                                transform="translate(-27.842 -67.191)"
                                fill="#ffb013"
                              ></path>
                              <path
                                id="Path_7628"
                                data-name="Path 7628"
                                d="M21.438,30.685h1.1v3.737h-1.1Z"
                                transform="translate(-5.057 -16.69)"
                                fill="#ff7833"
                              ></path>
                              <path
                                id="Path_7629"
                                data-name="Path 7629"
                                d="M18.652,46.259a.275.275,0,0,1-.275-.275V44.668a1.392,1.392,0,1,1,2.783,0v1.316a.275.275,0,0,1-.275.275Z"
                                transform="translate(-2.837 -25.819)"
                                fill="#ff5702"
                              ></path>
                              <path
                                id="Path_7630"
                                data-name="Path 7630"
                                d="M20.463,43.966a1.382,1.382,0,0,1,.371.938V46.22a.275.275,0,0,1-.275.275H18.385a.275.275,0,0,0,.273.263h2.233a.275.275,0,0,0,.275-.275V45.168A1.387,1.387,0,0,0,20.463,43.966Z"
                                transform="translate(-2.843 -26.32)"
                                fill="#eb5002"
                              ></path>
                              <path
                                id="Path_7631"
                                data-name="Path 7631"
                                d="M22.688,16.517a.273.273,0,0,1-.069-.009l-6.95-1.832a.275.275,0,0,1-.036-.519L28.7,8.688a.272.272,0,0,1,.106-.021.277.277,0,0,1,.106.021l13.059,5.469a.275.275,0,0,1-.036.519l-6.949,1.831a.268.268,0,0,1-.07.009.277.277,0,0,1-.108-.022,15.333,15.333,0,0,0-12.014,0,.272.272,0,0,1-.106.022Z"
                                transform="translate(-0.724 -0.725)"
                                fill="#fff"
                              ></path>
                              <path
                                id="Path_7632"
                                data-name="Path 7632"
                                d="M55.5,91.215l-.813-2.8L56.015,87h2.465l1.328,1.413-.813,2.8Z"
                                transform="translate(-29.165 -57.523)"
                                fill="#ffb013"
                              ></path>
                              <path
                                id="Path_7633"
                                data-name="Path 7633"
                                d="M50.444,30a16.444,16.444,0,0,0-12.878,0l-1.134.658,1.389.366A.27.27,0,0,0,38,31.009a15.333,15.333,0,0,1,12.014,0,.277.277,0,0,0,.108.022.268.268,0,0,0,.07-.009l1.48-.39Z"
                                transform="translate(-15.928 -15.24)"
                                fill="#483434"
                              ></path>
                              <path
                                id="Path_7634"
                                data-name="Path 7634"
                                d="M67.621,84.026a1.1,1.1,0,0,0,1.679-.048l3.244-4.069a7.966,7.966,0,0,1-2.8-2.012.277.277,0,0,0-.362-.055l-3.809,2.486h-.7a.818.818,0,0,0,.165.826Z"
                                transform="translate(-36.52 -50.851)"
                                fill="#c0c0c2"
                              ></path>
                              <path
                                id="Path_7635"
                                data-name="Path 7635"
                                d="M65.043,87.826l1.732,1.928.389-1.341L65.835,87h-.956a.818.818,0,0,0,.165.826Z"
                                transform="translate(-36.52 -57.523)"
                                fill="#fff"
                              ></path>
                              <path
                                id="Path_7636"
                                data-name="Path 7636"
                                d="M40.741,34.934V32.025l.167-.071a15.893,15.893,0,0,1,12.445,0l.167.071v2.909Z"
                                transform="translate(-19.053 -16.69)"
                                fill="#403134"
                              ></path>
                              <path
                                id="Path_7637"
                                data-name="Path 7637"
                                d="M35.208,79.927l3.182,3.988a1.1,1.1,0,0,0,1.677.05l2.58-2.875a.819.819,0,0,0,.162-.825h-.694l-3.788-2.509a.28.28,0,0,0-.366.055,7.8,7.8,0,0,1-2.8,2.037Z"
                                transform="translate(-15.005 -50.788)"
                                fill="#c0c0c2"
                              ></path>
                              <path
                                id="Path_7638"
                                data-name="Path 7638"
                                d="M54.687,88.413l.388,1.341,1.732-1.93A.819.819,0,0,0,56.97,87h-.955Z"
                                transform="translate(-29.165 -57.523)"
                                fill="#fff"
                              ></path>
                              <path
                                id="Path_7639"
                                data-name="Path 7639"
                                d="M43.53,80.727,40.951,83.6a.55.55,0,0,1-.838-.025l-3.167-3.97L36.94,79.6l.283-.159a7.458,7.458,0,0,0,1.77-1.328c.089-.1.18-.192.261-.294a.278.278,0,0,1,.366-.055l3.788,2.507.069.047a.273.273,0,0,1,.052.412Z"
                                transform="translate(-16.297 -50.791)"
                                fill="#ebf4ff"
                              ></path>
                              <path
                                id="Path_7640"
                                data-name="Path 7640"
                                d="M73.492,79.651,70.32,83.629a.55.55,0,0,1-.838.025L66.9,80.781a.273.273,0,0,1,.052-.412l.071-.047,3.808-2.485a.266.266,0,0,1,.151-.047.275.275,0,0,1,.212.1,6.033,6.033,0,0,0,1.066.992,8.934,8.934,0,0,0,.947.608c.094.053.191.1.283.159Z"
                                transform="translate(-37.97 -50.845)"
                                fill="#ebf4ff"
                              ></path>
                              <path
                                id="Path_7641"
                                data-name="Path 7641"
                                d="M86.867,48.765a1.267,1.267,0,0,0-.9-.357h-.991V50.12a5.333,5.333,0,0,1-.471,2.089c.069.112.912.018,1.026.018a1.677,1.677,0,0,0,1.62-1.6l.082-.843a1.375,1.375,0,0,0-.369-1.019Z"
                                transform="translate(-50.788 -29.54)"
                                fill="#ffdad1"
                              ></path>
                              <path
                                id="Path_7642"
                                data-name="Path 7642"
                                d="M87.175,51.644l-.075.768a1.677,1.677,0,0,1-1.62,1.6c-.078,0-.495.044-.774.036q-.086.255-.194.507c.069.112.912.018,1.026.018a1.677,1.677,0,0,0,1.62-1.6l.082-.843A1.706,1.706,0,0,0,87.175,51.644Z"
                                transform="translate(-50.79 -31.887)"
                                fill="#ffd3d1"
                              ></path>
                              <path
                                id="Path_7643"
                                data-name="Path 7643"
                                d="M35.809,50.113V48.4h-.981a1.267,1.267,0,0,0-.9.359,1.4,1.4,0,0,0-.368,1.045l.08.809a1.682,1.682,0,0,0,1.622,1.608c.183,0,1.015-.018,1.017-.014a5.333,5.333,0,0,1-.474-2.093Z"
                                transform="translate(-13.846 -29.535)"
                                fill="#ffdad1"
                              ></path>
                              <path
                                id="Path_7644"
                                data-name="Path 7644"
                                d="M47.04,54.349a4.488,4.488,0,0,1-2.687-1.065c-1.74-1.293-3.613-3.745-3.613-6.071V44.4H53.519v2.813c0,2.326-1.873,4.778-3.613,6.072a4.5,4.5,0,0,1-2.7,1.064Z"
                                transform="translate(-19.052 -26.634)"
                                fill="#ffdad1"
                              ></path>
                              <path
                                id="Path_7645"
                                data-name="Path 7645"
                                d="M85.088,34.691c-.192-.082-.385-.157-.58-.231v3.212h.746V34.762Z"
                                transform="translate(-50.788 -19.427)"
                                fill="#3d312f"
                              ></path>
                              <path
                                id="Path_7646"
                                data-name="Path 7646"
                                d="M57.11,71.641s0,0,0-.007a10.235,10.235,0,0,1-1.452,1.333,4.43,4.43,0,0,1-2.642,1.053h-.174a4.418,4.418,0,0,1-2.63-1.053,10.222,10.222,0,0,1-1.444-1.323s0,0,0,.007l-.02.11a10.322,10.322,0,0,0,1.917,1.888,4.488,4.488,0,0,0,2.687,1.065h.168a4.5,4.5,0,0,0,2.7-1.064A9.739,9.739,0,0,0,57.3,72.7Z"
                                transform="translate(-24.854 -46.381)"
                                fill="#ffc4ca"
                              ></path>
                              <path
                                id="Path_7647"
                                data-name="Path 7647"
                                d="M62.432,44.4v2.309c0,2.326-1.873,4.778-3.613,6.072a4.5,4.5,0,0,1-2.7,1.064h-.167a3.775,3.775,0,0,1-1.854-.518,4.416,4.416,0,0,0,2.628,1.022h.167a4.5,4.5,0,0,0,2.7-1.064c1.739-1.294,3.612-3.746,3.612-6.072V44.4Z"
                                transform="translate(-28.739 -26.634)"
                                fill="#ffd3d1"
                              ></path>
                              <path
                                id="Path_7648"
                                data-name="Path 7648"
                                d="M15.774,95.745a.275.275,0,0,1-.275-.286l.192-4.772c.073-1.8,1.588-2.74,2.722-3.294.426-.208.859-.4,1.278-.589l.568-.256,6.4,9.2Z"
                                transform="translate(-0.75 -57.196)"
                                fill="#fff"
                              ></path>
                              <path
                                id="Path_7649"
                                data-name="Path 7649"
                                d="M71.919,95.745l6.4-9.2.566.255c.423.189.857.383,1.281.59,1.134.554,2.65,1.5,2.722,3.294l.192,4.772a.275.275,0,0,1-.275.286Z"
                                transform="translate(-41.659 -57.196)"
                                fill="#fff"
                              ></path>
                              <path
                                id="Path_7650"
                                data-name="Path 7650"
                                d="M53.1,116.833l-.234.871h6.124l-.234-.871Z"
                                transform="translate(-27.842 -79.154)"
                                fill="#eb5002"
                              ></path>
                              <path
                                id="Path_7651"
                                data-name="Path 7651"
                                d="M15.523,116.833l-.024.585a.275.275,0,0,0,.275.286H26.656l-.6-.871Z"
                                transform="translate(-0.75 -79.154)"
                                fill="#483434"
                              ></path>
                              <path
                                id="Path_7652"
                                data-name="Path 7652"
                                d="M72.524,116.833l-.605.871H82.8a.275.275,0,0,0,.275-.286l-.024-.584Z"
                                transform="translate(-41.659 -79.154)"
                                fill="#483434"
                              ></path>
                              <path
                                id="Path_7653"
                                data-name="Path 7653"
                                d="M41.5,33.48c-.078-1.943-1.679-2.945-2.876-3.53-.422-.206-.856-.4-1.276-.587a10.116,10.116,0,0,1-3.908-2.493.55.55,0,0,0-.635-.158l-.234-1.2a9.857,9.857,0,0,0,1.616-2.465h.561A1.954,1.954,0,0,0,36.64,21.2l.081-.817,0-.052a1.644,1.644,0,0,0-.449-1.213,1.545,1.545,0,0,0-1.091-.44h-.442V15.94l6.539-1.723a.55.55,0,0,0,.072-1.039L28.295,7.71a.55.55,0,0,0-.424,0L14.8,13.178a.55.55,0,0,0,.072,1.039l1.508.4v2.663a1.668,1.668,0,0,0-1.117,1.571v1.316a.55.55,0,0,0,.55.55h2.233a.55.55,0,0,0,.55-.55V18.848a1.668,1.668,0,0,0-1.117-1.571V14.9l3.931,1.036v2.743h-.432a1.545,1.545,0,0,0-1.091.44,1.644,1.644,0,0,0-.449,1.213l.082.854a1.958,1.958,0,0,0,1.895,1.863h.552a9.854,9.854,0,0,0,1.613,2.464l-.223,1.166a.548.548,0,0,0-.616.168,9.792,9.792,0,0,1-3.9,2.505c-.428.189-.87.385-1.3.594-1.2.584-2.8,1.586-2.876,3.53l-.192,4.772a.555.555,0,0,0,.55.572H41.14a.559.559,0,0,0,.55-.572Zm-24-13.866H16.365v-.766a.567.567,0,1,1,1.134,0Zm7.639,7.348a4.738,4.738,0,0,0,2.851,1.119h.089a4.757,4.757,0,0,0,2.942-1.118c.2-.152.41-.321.615-.5l.175.892L28.973,29.2H27.194l-2.837-1.879.165-.863C24.727,26.641,24.933,26.81,25.137,26.962Zm.545,5.113.4,1.454-.93,3.458-4.91-7.06c.228-.106.454-.216.678-.332L23.8,33.21a.55.55,0,0,0,.414.207h.016a.55.55,0,0,0,.409-.183Zm1.36.791L26.554,31.1l.721-.8h1.617l.721.8-.489,1.763Zm3.038.663.4-1.454,1.039,1.158a.55.55,0,0,0,.409.183h.016a.55.55,0,0,0,.414-.207l2.887-3.62q.335.174.677.333l-4.914,7.065Zm4.2-4.493-2.375,2.979-1.933-2.155,2.946-1.923a7.568,7.568,0,0,0,1.362,1.1Zm.9-9.255a.457.457,0,0,1,.312.116.577.577,0,0,1,.128.409l-.079.8a.868.868,0,0,1-.8.842H34.57a5.212,5.212,0,0,0,.171-1.283v-.887Zm-7.1-10.969,11.352,4.754-5.2,1.371a16.171,16.171,0,0,0-12.31,0l-5.2-1.37Zm-5.57,7.077a15.062,15.062,0,0,1,11.129,0v1.693H22.513Zm-1.094,6.064a.874.874,0,0,1-.8-.857l-.078-.789a.577.577,0,0,1,.128-.409.457.457,0,0,1,.312-.116h.432v.888a5.213,5.213,0,0,0,.171,1.283Zm1.094-3.272H33.642v1.987c0,1.722-1.38,4-3.28,5.41a3.575,3.575,0,0,1-2.269.9h-.031a3.563,3.563,0,0,1-2.269-.9c-1.9-1.413-3.28-3.687-3.28-5.408Zm.754,9.237,2.927,1.94-1.935,2.158-2.369-2.972a7.469,7.469,0,0,0,1.378-1.124Zm-7.5,5.606c.042-1.046.739-1.844,2.259-2.586.391-.191.8-.373,1.2-.55l5.1,7.335H15.6Zm10.33,4.2,1.01-3.757h1.952l1.01,3.757Zm5.742,0,5.1-7.337c.4.178.808.361,1.2.551,1.521.742,2.217,1.54,2.26,2.586l.169,4.2Z"
                                transform="translate(0)"
                                fill="#032770"
                              ></path>
                            </g>
                          </svg>
                        </div>
                        <div className="university-card-content">
                          <h3>A Customizable Learning Environment</h3>
                          <p>
                            Personalized learning is an educational approach
                            that aims to customize learning for each student’s
                            strengths, needs, skills, and interests.
                          </p>
                        </div>
                      </div>
                      <div className="university-card-wrapper col-lg-3 col-sm-12">
                        <div className="university-card-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32.11"
                            height="31.157"
                            viewBox="0 0 32.11 31.157"
                          >
                            <g
                              id="_x31_9_Know_How"
                              transform="translate(0 -0.9)"
                            >
                              <g
                                id="Group_2915"
                                data-name="Group 2915"
                                transform="translate(0 0.9)"
                              >
                                <g
                                  id="Group_2910"
                                  data-name="Group 2910"
                                  transform="translate(0.502 0.502)"
                                >
                                  <path
                                    id="Path_7654"
                                    data-name="Path 7654"
                                    d="M12.9,1.9H30.711V26.233H12.9Z"
                                    transform="translate(-6.93 -1.9)"
                                    fill="#fff"
                                  ></path>
                                  <g id="Group_2909" data-name="Group 2909">
                                    <path
                                      id="Path_7655"
                                      data-name="Path 7655"
                                      d="M6.97,1.9H3.96A2.923,2.923,0,0,0,1,4.81V29.143a2.966,2.966,0,0,1,2.96-2.96H6.97Z"
                                      transform="translate(-1 -1.9)"
                                      fill="#4de2c9"
                                    ></path>
                                  </g>
                                  <path
                                    id="Path_7656"
                                    data-name="Path 7656"
                                    d="M24.782,56.27a5.617,5.617,0,0,1,0-5.87H3.96A2.934,2.934,0,0,0,1,53.36a2.966,2.966,0,0,0,2.96,2.96Z"
                                    transform="translate(-1 -26.067)"
                                    fill="#fff"
                                  ></path>
                                </g>
                                <g
                                  id="Group_2911"
                                  data-name="Group 2911"
                                  transform="translate(22.161 20.872)"
                                >
                                  <path
                                    id="Path_7657"
                                    data-name="Path 7657"
                                    d="M48.4,50.227a2.114,2.114,0,1,1-4.214-.251l.8-7.476h2.659C48.4,50.277,48.4,50.026,48.4,50.227Z"
                                    transform="translate(-44.17 -42.5)"
                                    fill="#ffcd7e"
                                  ></path>
                                </g>
                                <path
                                  id="Path_7658"
                                  data-name="Path 7658"
                                  d="M48.416,37.7v1.4a1.006,1.006,0,0,1-1,1H44.7a1.006,1.006,0,0,1-1-1V37.7a7.128,7.128,0,0,0,4.716,0Z"
                                  transform="translate(-21.775 -19.237)"
                                  fill="#fff"
                                ></path>
                                <g
                                  id="Group_2912"
                                  data-name="Group 2912"
                                  transform="translate(16.958 4.214)"
                                >
                                  <path
                                    id="Path_7659"
                                    data-name="Path 7659"
                                    d="M48.45,16.625A7.325,7.325,0,1,1,41.125,9.3,7.3,7.3,0,0,1,48.45,16.625Z"
                                    transform="translate(-33.8 -9.3)"
                                    fill="#ff787d"
                                  ></path>
                                </g>
                                <g id="Group_2914" data-name="Group 2914">
                                  <path
                                    id="Path_7660"
                                    data-name="Path 7660"
                                    d="M48.436,18.668A5.268,5.268,0,1,1,43.168,13.4,5.267,5.267,0,0,1,48.436,18.668Z"
                                    transform="translate(-18.885 -7.128)"
                                    fill="#fff"
                                  ></path>
                                  <g id="Group_2913" data-name="Group 2913">
                                    <path
                                      id="Path_7661"
                                      data-name="Path 7661"
                                      d="M22.7,9.3h7.476a.5.5,0,0,0,0-1H22.7a.5.5,0,0,0,0,1Z"
                                      transform="translate(-11.062 -4.587)"
                                      fill="#33226e"
                                    ></path>
                                    <path
                                      id="Path_7662"
                                      data-name="Path 7662"
                                      d="M32.11,12.44a7.848,7.848,0,0,0-7.325-7.827V1.4a.474.474,0,0,0-.5-.5H3.462A3.459,3.459,0,0,0,0,4.312V28.645a3.415,3.415,0,0,0,3.412,3.412H24.233a2.591,2.591,0,0,0,2.609-2.609c0-.2,0,0-.753-7.325a1.529,1.529,0,0,0,1-1.4v-1.1A7.565,7.565,0,0,0,32.11,12.44ZM23.782,4.613a7.946,7.946,0,0,0-5.268,2.509H9.884a.5.5,0,0,0,0,1h7.877a15.118,15.118,0,0,0-.8,1.555H9.884a.5.5,0,1,0,0,1h6.773a7.756,7.756,0,0,0-.2,1.555H11.64a.5.5,0,1,0,0,1h4.867a7.833,7.833,0,0,0,4.917,6.472v1.1a1.461,1.461,0,0,0,1,1.4l-.351,3.01H6.974V1.9H23.782ZM25.638,21.27H22.929a.5.5,0,0,1-.5-.5v-.753a7.745,7.745,0,0,0,3.713,0v.753A.5.5,0,0,1,25.638,21.27ZM1,4.312A2.452,2.452,0,0,1,3.412,1.853H5.92v23.33H3.412a3.412,3.412,0,0,0-2.408,1ZM1,28.7a2.409,2.409,0,0,1,2.408-2.408H21.925l-.2,1.907H6.422a.5.5,0,0,0-.5.5.474.474,0,0,0,.5.5h15.2a2.546,2.546,0,0,0,.552,1.957H3.462A2.53,2.53,0,0,1,1,28.7ZM24.283,31.1a1.6,1.6,0,0,1-1.2-.552,1.652,1.652,0,0,1-.4-1.254l.753-7.024h1.756c.552,5.569.753,7.124.753,7.225A1.66,1.66,0,0,1,24.283,31.1Zm0-11.841a6.823,6.823,0,1,1,6.823-6.823,6.831,6.831,0,0,1-6.823,6.823Z"
                                      transform="translate(0 -0.9)"
                                      fill="#33226e"
                                    ></path>
                                    <path
                                      id="Path_7663"
                                      data-name="Path 7663"
                                      d="M42.67,12.4a5.77,5.77,0,1,0,5.77,5.77,5.8,5.8,0,0,0-5.77-5.77Zm0,10.536a4.766,4.766,0,1,1,4.766-4.766A4.8,4.8,0,0,1,42.67,22.936Z"
                                      transform="translate(-18.386 -6.63)"
                                      fill="#33226e"
                                    ></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div className="university-card-content">
                          <h3>A More Sustainable Option</h3>
                          <p>
                            Embracing sustainable learning empowers educators
                            and learners alike to take action and implement
                            solutions to challenges in rapidly changing
                            environments.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="university-message-area pt-5 pb-5">
              <div className="container">
                <div className="row">
                  <div className="col-xl-4 col-lg-4">
                    <div className="section-title mb-4">
                      <h2>
                        Welcome to
                        <span
                          className="down-mark-line-2"
                          style={{ color: "#0d61ac", fontWeight: "bold" }}
                        >
                          ISBM University
                        </span>
                        Education Online Platform
                      </h2>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4">
                    <div className="message-profile-text">
                      <span>
                        An LMS is an amazing platform that can do wonders to
                        improve training and learning activities.
                      </span>
                      <p>
                        In this tech-driven world, traditional teaching and
                        learning can be easily interrupted or sometimes
                        inefficient, which is why learners need more interactive
                        and captivating educational methods.
                      </p>
                      <a
                        className="edu-six-btn px-3 py-2"
                        target="/"
                        href="http://isbmuniversity.online/login"
                      >
                        View More About LMS
                      </a>
                    </div>
                  </div>
                  
                  <div className="col-xl-4 col-lg-4">
                    <div className="message-sticker position-relative">
                      <img
                        src={imgLMS}
                        alt="ISBM Top university for diploma"
                      ></img>
                      <div className="etablist-price">
                        <p>
                          
                          <span>LMS</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="benefits-contain">
                    <p className="emphasis_p text_center">
                      Here are the <strong>main benefits</strong> of using
                      <strong>LMS</strong>
                    </p>
                    <div className="benefits-main">
                      <div className="taglines left-side">
                        <div className="tagline item-1">
                          <p>
                            Boosts student engagement, employee productivity,
                            and performance
                          </p>
                        </div>

                        <div className="tagline item-2">
                          <p>
                            Instructors and teachers <strong>save time</strong>
                            in daily teaching and training tasks
                          </p>
                        </div>

                        <div className="tagline item-3">
                          <p>
                            The <strong>perfect solution</strong> to train
                            Students
                          </p>
                        </div>
                      </div>
                      <div className="center-image">
                        <img src={lmslaptop} alt="lms-laptop"></img>
                      </div>
                      <div className="taglines right-side">
                        <div className="tagline item-1">
                          <p>
                            Easily <strong>track learner progress</strong> at
                            each stage of the learning process
                          </p>
                        </div>

                        <div className="tagline item-2">
                          <p>
                            Empowering learners to
                            <strong>set their own learning pace. </strong>
                          </p>
                        </div>

                        <div className="tagline item-3">
                          <p>
                            <strong>Reduces costs</strong> for training and
                            classroom consumables
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="academic-courses-area p-relative pt-5 pb-5">
              <img
                className="academic-shape-2"
                src={acadShape2}
                alt="shape"
              ></img>
              <div className="container">
                <div className="row">
                  <div className="videoInfo col-xl-8 col-lg-6 col-md-6">
                    <div className="compus-content mb-3">
                      <div className="section-title mb-3">
                        <h2>
                          Video
                          <span className="down-mark-line-2">Lectures</span>
                        </h2>
                      </div>
                      <p>
                        Video ensures learners memorize data faster, improves
                        the availability of learning materials, and promotes
                        engagement.
                      </p>
                      <ul>
                        <li>
                          <i className="far fa-check"></i>Easy to access anytime
                        </li>
                        <li>
                          <i className="far fa-check"></i>Learn whenever you
                          want
                        </li>
                        <li>
                          <i className="far fa-check"></i>Learning at an
                          individual pace
                        </li>
                        <li>
                          <i className="far fa-check"></i>Opportunity for
                          self-study
                        </li>
                      </ul>
                      <div className="col-xl-3 text-center center-button">
                        <div className="academic-bottom-btn ">
                          <a
                            className="edo-theme-btn mt-30"
                            target="/"
                            href="http://www.isbm.online/"
                          >
                            View More Videos
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 col-md-6">
                    <div >
                      <div className="academic-box position-relative mb-30">
                        <img
                          className="academic-shape"
                          src={acadShape1}
                          alt="image not found"
                        ></img>
                        <div className="academic-thumb">
                          <iframe
                            width="350"
                            height="200"
                            target="/"
                            src="https://www.youtube.com/embed/pM-a6YTLOUE"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                    <div >
                      <div className="academic-box mb-4">
                        <div className="academic-thumb">
                          <iframe
                            width="350"
                            height="200"
                            target="/"
                            src="https://www.youtube.com/embed/dshNUBTFufo"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="counter-area pt-5 pb-4"
              style={{ background: "#0b79ff" }}
            >
              <div>
                <div className="section-title mb-30">
                  <h2
                    style={{
                      textAlign: "center",
                      color: "#FFF",
                      fontWeight: "bold",
                    }}
                  >
                    Enrich your
                    <span className="down-mark-line-2">Knowledge</span>
                  </h2>
                </div>
              </div>
              <div className="row testheader">
                Do you want to accomplish great achievements in your life?
                Prepare yourself to face numerous obstacles because every
                challenge is going to carve the best out of you.
              </div>
              <div className="row" style={{ justifyContent: "space-evenly" }}>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="event-tour">
                    <div>
                      <h3>
                        <a href="https://forms.gle/C9KhaH6JKfUQZdLZ6">
                          Quantitative Aptitude
                        </a>
                      </h3>
                      <span>
                      <i className="fa-solid fa-clock"></i>10 Mins
                      </span>
                      <span>
                        <i className="flaticon-place"></i>
                        <a
                          href="https://forms.gle/C9KhaH6JKfUQZdLZ6"
                          target="_blank"
                          className=""
                        >
                          Attempt your Test
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="event-tour">
                    <div >
                      <h3>
                        <a href="https://forms.gle/BFzsvMTn27QSwq7q9">
                          Social Science Quiz
                        </a>
                      </h3>
                      <span>
                      <i className="fa-solid fa-clock"></i>10 Mins
                      </span>
                      <span>
                        <i className="flaticon-place"></i>
                        <a
                          href="https://forms.gle/BFzsvMTn27QSwq7q9"
                          target="_blank"
                          className=""
                        >
                          Attempt your Test
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="event-tour">
                    <div >
                      <h3>
                        <a href="https://forms.gle/EVrwoSPHcuTseRUdA">
                          Verbal Ability Quiz
                        </a>
                      </h3>
                      <span>
                      <i className="fa-solid fa-clock"></i>10 Mins
                      </span>
                      <span>
                        <i className="flaticon-place"></i>
                        <a
                          href="https://forms.gle/EVrwoSPHcuTseRUdA"
                          target="_blank"
                          className=""
                        >
                          Attempt your Test
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                  <div className="event-tour">
                    <div>
                      <h3>
                        <a href="">Modal Question Papers 12th-Arts</a>
                      </h3>
                      <div className="row">
                        <div
                          className="col"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>English</span>
                          </a>

                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Geography</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Hindi</span>
                          </a>
                        </div>
                        <div
                          className="col"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>History</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Political Science</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Sociology</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="event-tour">
                    <div >
                      <h3>
                        <a href="">Modal Question Papers 12th-Commerce</a>
                      </h3>
                      <div className="row">
                        <div
                          className="col"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Accountancy</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Business Study</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Hindi</span>
                          </a>
                        </div>
                        <div
                          className="col"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>English</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Economics</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="event-tour">
                    <div >
                      <h3>
                        <a href="">Modal Question Papers 12th-Science</a>
                      </h3>
                      <div className="row">
                        <div
                          className="col"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Biology</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Biology</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Chemistry</span>
                          </a>
                        </div>
                        <div
                          className="col"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Mathematics</span>
                          </a>
                          <a
                            href="https://isbmuniversity.edu.in/savedata.php"
                            className="paperLink"
                          >
                            <BsDownload className="me-3"/>
                            <span>Physics</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <img src={Questionmark} alt="image not found"></img>
                </div>
              </div>
            </div>

            <div className="campus-area fix pt-5 pb-5 ">
              <div className="container">
                <div className="campus-wrapper position-relative">
                  <div className="campus-shape-sticker">
                    <div className="shape-light">
                      <img src={shapelight} alt="image not found"></img>
                    </div>
                    <div className="campus-shape-content">
                      <h5>
                        Books That<span> Matter</span>
                      </h5>
                    </div>
                  </div>
                  <div className="campus-shape-1">
                    <img src={campusshape2} alt="shape"></img>
                  </div>
                  <div className="campus-shape-2">
                    <img src={studentshape05} alt="shape"></img>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-xl-5 col-lg-6">
                      <div className="compus-content mb-4">
                        <div className="section-title mb-4">
                          <h2>
                            Find Books From
                            <span className="down-mark-line-2">
                              
                              All Categories
                            </span>
                          </h2>
                        </div>
                        <p>
                          Schools and corporate organizations are increasingly
                          moving towards eBooks for training purposes because
                          eBooks are better equipped to provide an engaging
                          learning and reading experience to users.
                        </p>
                        <ul>
                          <li>
                            <i className="far fa-check"></i>One Device, Many
                            Books
                          </li>
                          <li>
                            <i className="far fa-check"></i>Accessible
                            Everywhere
                          </li>
                          <li>
                            <i className="far fa-check"></i>Shareable Content
                          </li>
                          <li>
                            <i className="far fa-check"></i>Easily Updates
                          </li>
                        </ul>
                        <div className="col-xl-3 text-center center-button">
                          <div className="academic-bottom-btn ">
                            <a
                              className="edo-theme-btn mt-30"
                              href="http://isbmuniversity.online/login"
                            >
                              Discover Your Next Book
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 offset-xl-1 col-lg-6">
                      <div className="campus-img-wrapper position-relative">
                        <div className="campus-shape-3">
                          <img src={campusshape1} alt="image not found"></img>
                        </div>
                        <div className="campus-img-1">
                          <img
                            src={campusimg1}
                            alt="Best University for Information and Technology"
                          ></img>
                        </div>
                        <div className="campus-img-2">
                          <img
                            src={campusimg2}
                            alt="Best university for masters"
                          ></img>
                        </div>
                        <div className="campus-img-3">
                          <img
                            src={campusimg3}
                            alt="Top university for Management studies"
                          ></img>
                        </div>
                        <div className="campus-img-4">
                          <img
                            src={campusimg4}
                            alt="Best university for hotel management"
                          ></img>
                        </div>
                        <div className="campus-img-5">
                          <img
                            src={campusimg5}
                            alt="Best university for professional Studies"
                          ></img>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tips-section"
              aria-label="ISBM top 10 law college in india"
            >
              <img
                src={infographics25}
                className="tipsImgs"
                alt="image not found"
              ></img>
            </div>

            <div className="blog-area pt-5 pb-4">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-12 text-center">
                    <div className="section-title mb-4">
                      <h2>
                        Skill
                        <span className="down-mark-line-2">Development</span>
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-6">
                    <img
                     src="https://isbmuniversity.edu.in/static/media/pm-modi.5f72dfb7.jpg"
                      style={{ width: "100%" }}
                      className=""
                      alt="Best mca colleges in india"
                    ></img>
                  </div>
                  <div
                    className="col-xl-4 col-lg-4 col-md-6"
                    style={{ display: "flex" }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <img
                        src="https://isbmuniversity.edu.in/static/media/fire-sefty.c89ff35a.jpg"
                        style={{ width: "100%" }}
                        className=""
                        alt="bca universities in india"
                      ></img>
                      <img
                        src=""
                        style={{ width: "100%" }}
                        className=""
                        alt="best college for b.tech"
                      ></img>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <img
                        src=""
                        style={{ width: "100%" }}
                        className=""
                        alt="post graduate courses in india"
                      ></img>
                      <img
                        src=""
                        style={{ width: "100%" }}
                        className=""
                        alt="mca universities in india"
                      ></img>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6">
                    <img
                      src=""
                      style={{ width: "100%" }}
                      className=""
                      alt="image not found"
                    ></img>
                  </div>
                </div>
                <div className="imgtab">
                  <div className="Skillcard">
                    <h4 style={{ color: "rgb(13, 97, 172)" }}>
                      <b>
                        We make VOCATIONAL TRAINING inspirational to transform
                        INDIA into the SKILL CAPITAL of the world.
                      </b>
                    </h4>
                    <p>
                      In partnership with the Ministry of Skill Development &
                      Entrepreneurship (MSDE) and National Skill Development
                      Corporation (NSDC), we have launched a state-of-the-art
                      Model Training Centre (MTC), called Pradhan Mantri Kaushal
                      Kendra (PMKK) in Gariyabandh, Chhattisgarh.
                    </p>
                    <p>
                      We in association with the Ministry and NSDC, are playing
                      a pivotal role in creating benchmark institutions that
                      demonstrate aspirational value for competency based skill
                      development training by focusing on elements of quality,
                      sustainability and connect with youth. By addressing the
                      challenges of unemployment and ensuring gainful employment
                      for the youth of the state, we are enabling and mobilizing
                      Chhattisgarh youth to make them employable and work ready.
                    </p>
                    <div className="readmore">
                      <Link to="/skill-development" className="text-dark fs-5 text-decoration-underline">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Isbm_pro;
